import React from 'react';

const formatCredits = (num) => {
  if (num >= 1_000_000) return `${(num / 1_000_000).toFixed(1)}M`;
  return num.toLocaleString();
};

const LowCreditsBanner = ({ credits, isFreePlan, onDismiss, onUpgrade, onTopUp }) => {
  const isZero = credits.available === 0;

  if (isZero) {
    return (
      <div className="flex items-center gap-3 px-4 py-2.5 rounded-xl bg-gradient-to-r from-blue-500/[0.08] via-cyan-500/[0.06] to-purple-500/[0.04] dark:from-blue-500/[0.12] dark:via-cyan-500/[0.08] dark:to-purple-500/[0.05] border border-cyan-400/20 dark:border-cyan-400/15">
        {/* Icon */}
        <div className="flex-shrink-0 w-7 h-7 rounded-lg p-[1.5px] bg-gradient-to-br from-blue-400 via-cyan-400 to-purple-400 shadow-sm shadow-cyan-500/15">
          <div className="w-full h-full bg-white dark:bg-gray-900 rounded-[6px] flex items-center justify-center">
            <svg className="w-3.5 h-3.5 text-cyan-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
            </svg>
          </div>
        </div>

        {/* Text */}
        <p className="flex-1 text-sm text-gray-600 dark:text-gray-300">
          <span className="font-semibold text-gray-800 dark:text-white">You're out of credits.</span>
          {' '}Your automations can't run until you top up or upgrade.
        </p>

        {/* CTA */}
        <button
          onClick={onUpgrade}
          className="flex-shrink-0 px-3.5 py-1.5 rounded-lg text-xs font-bold bg-gradient-to-r from-blue-500 via-cyan-500 to-purple-500 text-white hover:from-blue-600 hover:via-cyan-600 hover:to-purple-600 transition-all duration-200 shadow-sm shadow-cyan-500/20 hover:shadow-cyan-500/30"
        >
          Upgrade
        </button>
      </div>
    );
  }

  // Low credits (<20%)
  return (
    <div className="flex items-center gap-3 px-4 py-2.5 rounded-xl bg-amber-50/80 dark:bg-amber-900/10 border border-amber-200/60 dark:border-amber-700/20">
      {/* Pulsing dot */}
      <span className="relative flex-shrink-0 flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-400" />
      </span>

      {/* Text */}
      <p className="flex-1 text-sm text-gray-600 dark:text-gray-400">
        <span className="font-semibold text-amber-700 dark:text-amber-300">{formatCredits(credits.available)}</span> credits remaining
      </p>

      {/* CTA */}
      <button
        onClick={isFreePlan ? onUpgrade : (onTopUp || onUpgrade)}
        className="flex-shrink-0 text-xs font-semibold bg-gradient-to-r from-blue-400 via-cyan-400 to-purple-400 bg-clip-text text-transparent hover:from-blue-500 hover:via-cyan-500 hover:to-purple-500 transition-all"
      >
        {isFreePlan ? 'Upgrade Plan' : 'Top Up'}
      </button>

      {/* Dismiss */}
      <button
        onClick={onDismiss}
        className="flex-shrink-0 p-0.5 text-gray-400 dark:text-gray-600 hover:text-gray-600 dark:hover:text-gray-400 transition-colors"
      >
        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};

export default LowCreditsBanner;
